import React from "react";
import PropTypes from 'prop-types';
import TopMenu from './header/TopMenu';
import MenuMobile from './header/MenuMobile';

export default class Header extends React.PureComponent {
    componentDidMount() {

    }
    toggleMobileMenu = () => {
        let { isMobileMenuVisible, showMobileMenu, hideMobileMenu } = this.props;

        if (isMobileMenuVisible) {
            hideMobileMenu();
        } else {
            showMobileMenu();
        }
    };

    mobileMenuClickHandler = () => {
        let { hideMobileMenu } = this.props;

        hideMobileMenu();
    };

    render() {
        let {
            isLogged,
            isMobileMenuVisible,
            isHeader,
            userData,
            isMenu,
            innerComponent,
            logout,
            className,
            isVerified,
            /*isVideoIntro,
            isVideoIntroComplete,*/
            isSignUpAvailable,
            heroSectionMode,
            registerPageView,
            isGetMePending,
        } = this.props;

        if (!isHeader) {
            return false;
        }

        let headerClassName = 'header';

        if (!isVerified) {
            headerClassName += ' unverified-user';
        }
        if (className) {
            headerClassName += ` ${className}`;
        }
        /*if (isVideoIntro) {
            headerClassName += ` video-intro`;
        }
        if (isVideoIntroComplete) {
            headerClassName += ` video-intro-complete`;
        }*/
        if (isMobileMenuVisible) {
            headerClassName += ` mobile-menu-visible`;
        }
        return (
            <div className={headerClassName}>
                <TopMenu
                    heroSectionMode={heroSectionMode}
                    registerPageView={registerPageView}
                    className={className}
                    logout={logout}
                    innerComponent={innerComponent}
                    isMenu={isMenu}
                    isLogged={isLogged}
                    userData={userData}
                    isMobileMenuVisible={isMobileMenuVisible}
                    isSignUpAvailable={isSignUpAvailable}
                    isGetMePending={isGetMePending}
                    toggleMobileMenu={this.toggleMobileMenu}/>

                <MenuMobile
                    logout={logout}
                    isLogged={isLogged}
                    isVisible={isMobileMenuVisible}
                    isSignUpAvailable={isSignUpAvailable}
                    onMenuItemClick={this.mobileMenuClickHandler}
                />
            </div>
        );
    }
}

Header.propTypes = {
    isVerified: PropTypes.bool,
    innerComponent: PropTypes.node,
    isMenu: PropTypes.bool,
    userData: PropTypes.object.isRequired,
    isLogged: PropTypes.bool.isRequired,
    isVideoIntro: PropTypes.bool.isRequired,
    isMobileMenuVisible: PropTypes.bool.isRequired,
    isSignUpAvailable: PropTypes.bool.isRequired,
    isGetMePending: PropTypes.bool.isRequired,
    isHeader: PropTypes.bool.isRequired,

    className: PropTypes.string,
    hideHeader: PropTypes.func.isRequired,
    showHeader: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    registerPageView: PropTypes.func.isRequired,
    heroSectionMode: PropTypes.string,
};
